export default {"src":"/_next/static/media/pot.be4494ce.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};